export default {
    name: 'LEASE SUMMARY',
    rows: {
        'original-lease-term': {
            name: 'Original Lease Term',
            editable: false,
            tooltip: '= lease_expiration - lease_commencement',
            getComputedValue: function (tables) {
                const leaseCommencementDate = new Date(tables['lease-summary'].rows['lease-commencement'].value);
                const leaseExpirationDate = new Date(tables['lease-summary'].rows['lease-expiration'].value);
                const months = (leaseExpirationDate - leaseCommencementDate) / 1000 / 60 / 60 / 24 / 30 / 12;
                const value = months ? months % 1 < 0.5 ? parseInt(months) : parseInt(months) + 0.5 : 0;
                const displayValue = value && !isNaN(value) ? `${value} ${value <= 1 ? 'Year' : 'Years'}` : '-';
                return {internalValue: value, displayValue: displayValue}
            },
        },
        'lease-commencement': {
            name: 'Lease Commencement',
            type: 'date',
            editable: true,
            value: '',
        },
        'lease-expiration': {
            name: 'Lease Expiration',
            type: 'date',
            editable: true,
            value: '',
        },
        'remaining-term': {
            name: 'Remaining Term',
            unit: 'Years',
            type: 'number',
            editable: false,
            getComputedValue: function (tables) {
                const leaseExpiration = new Date(tables['lease-summary'].rows['lease-expiration'].value);
                const analysisDate = new Date(tables['general-information'].rows['analysis-date'].value);
                const months = (leaseExpiration - analysisDate) / 1000 / 60 / 60 / 24 / 30 / 12;
                let value = months ? months % 1 < 0.5 ? parseInt(months) : parseInt(months) + 0.5 : 0;
                const displayValue = value && !isNaN(value) ? `${value} ${value <= 1 ? 'Year' : 'Years'}` : '-';
                return {internalValue: value, displayValue: displayValue};
            }
        },
        'lease-type': {
            name: 'Lease Type',
            unit: '',
            type: 'dropdown',
            editable: true,
            value: 'Ground',
            dropdownValues: '',
        },
        'roof-and-structure': {
            name: 'Roof & Structure',
            unit: '',
            editable: false,
            tooltip: '= IF(lease_type = Ground OR lease_type = NNN) Tenant ELSE Landlord',
            getComputedValue: function (tables) {
                const leaseType = tables['lease-summary'].rows['lease-type'].value;
                let value = '';

                if (!leaseType || leaseType === '-') {
                    value = '-';
                } else if (leaseType === 'Ground' || leaseType === 'NNN') {
                    value = 'Tenant';
                } else {
                    value = 'Landlord';
                }

                return {internalValue: value, displayValue: value};
            }
        },
        'increases': {
            name: 'Increases',
            unit: '',
            type: 'text',
            editable: true,
            value: '',
        },
        'guarantor': {
            name: 'Guarantor',
            unit: '',
            type: 'dropdown',
            editable: true,
            value: '',
            dropdownValues: '',
        },
        'options': {
            name: 'Options',
            unit: '',
            type: 'text',
            editable: true,
            value: '',
        },
        'options-to-purchase': {
            name: 'Options to Purchase',
            unit: '',
            type: 'dropdown',
            editable: true,
            value: '',
            dropdownValues: '',
        },
    }
};